// 手机号验证
function isvalidPhone(str) {
    const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
    return reg.test(str)
  }

  // 验证邮箱 
function isvalidEmail(str) {
    const reg =   /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
    return reg.test(str)
  }

export {
  isvalidPhone,
  isvalidEmail
}


// WEBPACK FOOTER //
// ./src/tools/validate.js